import React, { useEffect, useState } from 'react'
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CardContent from '@material-ui/core/CardContent'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import CardActions from '@material-ui/core/CardActions'
import { Flex } from 'rebass'
import LoadingIcon from '../../assets/img/loading.svg'

interface SuggestionsMenuListItemProps {
  utterance: string
  index: number
  handleClose?: () => void
  askHandler?: (utterance: string) => void
  askTimeout?: number
  areRowsContained?: boolean
}

const useListItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      margin: theme.spacing(1),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.primary.contrastText
    },
    content: {
      alignItems: 'flex-start'
    },
    actions: {
      alignItems: 'flex-end'
    },
    askButton: {
      marginLeft: theme.spacing(1),
      color: theme.palette.getContrastText(theme.palette.primary.main)
    },
    endIcon: {
      width: '1em',
      height: '1em'
    }
  })
)

const SuggestionsMenuListItem: React.FC<SuggestionsMenuListItemProps> = ({
  utterance,
  index,
  handleClose,
  askHandler,
  askTimeout = 3000,
  areRowsContained = true
}) => {
  const listItemClasses = useListItemStyles()
  const [sending, setSending] = useState(false)
  let sendTimeout: NodeJS.Timeout
  let isMounted = false

  const clickItemHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSending(true)
    console.log('Ask: ', utterance)
    if (askHandler) {
      askHandler(utterance)
      if (handleClose) {
        //handleClose()
      }

      sendTimeout = setTimeout(() => {
        //if (isMounted) {
        sendTimeoutHandler()
        //}
      }, askTimeout)
    }

    // TODO: not possible to manually trigger click() event on iframe content from host page.
  }

  const sendTimeoutHandler = () => {
    setSending(false)
  }

  useEffect(() => {
    isMounted = true
    /* clean up send timeout handler when component unmounts */
    return () => {
      if (isMounted) {
        clearTimeout(sendTimeout)
      }
      isMounted = false
    }
  }, [])

  return (
    <React.Fragment>
      {areRowsContained ? (
        <Card variant="outlined" className={listItemClasses.card}>
          <CardContent className={listItemClasses.content}>
            {utterance}
          </CardContent>
          <CardActions className={listItemClasses.actions}>
            <Button
              variant="contained"
              color="secondary"
              className={listItemClasses.askButton}
              onClick={clickItemHandler}
              disabled={sending}
              tabIndex={index}
              endIcon={
                sending ? (
                  <img src={LoadingIcon} className={listItemClasses.endIcon} />
                ) : (
                  <React.Fragment></React.Fragment>
                )
              }
            >
              {sending ? '' : 'Ask'}
            </Button>
          </CardActions>
        </Card>
      ) : (
        <Flex sx={{ justifyContent: 'space-between' }}>
          <CardContent className={listItemClasses.content}>
            <Typography variant="body1" color="primary">
              {utterance}
            </Typography>
          </CardContent>
          <CardActions className={listItemClasses.actions}>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              className={listItemClasses.askButton}
              onClick={clickItemHandler}
              disabled={sending}
              tabIndex={index}
              endIcon={
                sending ? (
                  <img src={LoadingIcon} className={listItemClasses.endIcon} />
                ) : (
                  <React.Fragment></React.Fragment>
                )
              }
            >
              {sending ? '' : 'Ask'}
            </Button>
          </CardActions>
        </Flex>
      )}
    </React.Fragment>
  )
}

export default SuggestionsMenuListItem
